export default function Products() {
  return <div className="text-xl font-semibold">Promotable Products</div>;
}
